module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.svg?5bafbe652c040ec958005a1a255dddf0";